import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { AlertController, ModalController } from '@ionic/angular';
import { AuthService } from 'src/app/services/auth.service';
import { ToolsService } from 'src/app/services/tools.service';
import { ConfirmTermsAndConditionComponent } from '../confirm-terms-and-condition/confirm-terms-and-condition.component';

@Component({
  selector: 'app-buttons-modal',
  templateUrl: './buttons-modal.component.html',
  styleUrls: ['./buttons-modal.component.scss'],
})
export class ButtonsModalComponent {
  @Input() buttons: any[] = [];
  @Output() goToLogin = new EventEmitter<any>();

  constructor(
    private modalCtrl: ModalController,
    private authService: AuthService,
    private alertCtrl: AlertController,
    private toolService: ToolsService,
    private router: Router
  ) {}

  close() {
    this.modalCtrl.dismiss();
  }

  // async openModal(role: number, data: any) {
  //   const modal = await this.modalCtrl.create({
  //     component: ConfirmTermsAndConditionComponent,
  //     componentProps: {
  //       role,
  //       data,
  //       full: true,
  //     },
  //     cssClass: 'custom-modal',
  //     showBackdrop: true,
  //   });

  //   modal.onDidDismiss().then((data) => {
  //     this.modalCtrl.dismiss(true);
  //     // this.nextPage.emit('login');
  //     // this.router.navigate(['/'], {
  //     //   queryParams: { role: this.role, start: true },
  //     // });
  //   });
  //   await modal.present();
  // }

  async openModal(role: number, data: any) {
    const modal = await this.modalCtrl.create({
      component: ConfirmTermsAndConditionComponent,
      componentProps: {
        role,
        data,
        full: true,
      },
      cssClass: 'custom-modal',
      showBackdrop: true,
    });

    modal.onDidDismiss().then((resp) => {
      if (resp.data?.goToLogin) {
        this.modalCtrl.dismiss({
          goToLogin: true,
          role: role,
        });
      }
    });

    await modal.present();
  }


  openTyC(url: string) {
    window.open(url, '_blank', 'noopener,noreferrer');
  }

  async getButtons() {
    await this.authService.getButtonsRoles().subscribe((response) => {
      if (response.length > 0) {
        this.buttons = response;
      } else {
        this.close();
      }
    });
  }

  saveRolRequest(id: number) {
    this.authService.saveRol(id).subscribe({
      next: () => {
        this.getButtons();
        this.toolService.presentSucessToast('Rol asignado correctamente.'); // Mensaje de éxito
      },
      error: (error) => {
        console.error('Error al asignar el rol:', error);
        this.toolService.presentErrorToast(
          'Hubo un error al asignar el rol. Inténtalo de nuevo.'
        );
      },
    });
  }

  getTextColor(hex: string): string {
    if (!hex) return 'white'; // Color por defecto si no hay valor

    hex = hex.replace('#', '');

    if (hex.length === 3) {
      hex = hex
        .split('')
        .map((char) => char + char)
        .join('');
    }

    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

    return luminance > 0.5 ? 'black' : 'white';
  }
}
